<template>
  <div class="table" :class="[tableStatusClass, { selected: selected }]">
    <a class="table-container" @click="$emit('click')">
      <div v-if="table.status_id !== 1" class="table-length">
        <span class="badge ts-font-semibold" :class="false ? 'bg-overtime' : ''">
          <span>{{ minutesUsed }}</span>
        </span>
      </div>
      <div class="table-status"></div>
      <div class="table-name">
        <div class="name">{{ $t('restaurantSale.table') }}</div>
        <div class="no">{{ table.table_no }}</div>
        <div class="countdown">
          <span class="countdown-timer">
            <span>{{ product.product_name_en }}</span>
          </span>
        </div>
      </div>
      <div class="table-info-row">
        <div class="table-info-col">
          <div class="table-info-container">
            <span class="icon">
              <span v-show="table.status_id != 1">🕐</span>
            </span>
            <span class="text">{{ startTime }}</span>
          </div>
        </div>
        <div class="table-info-col">
          <div class="table-info-container">
            <span class="icon">
              <span v-show="table.status_id != 1">
                <i class="fas fa-stopwatch"></i>
              </span>
            </span>
            <span class="text">{{ endTime }}</span>
          </div>
        </div>
      </div>
      <div class="table-info-row">
        <div class="table-info-col">
          <div class="table-info-container">
            <ts-button v-if="product.end_time" class="btn-primary">
              <i class="fas fa-check fa-fw"></i>
              {{ $t('restaurantSale.completed') }}</ts-button>
            <ts-button v-else-if="!product.start_time" class="btn-success" @click.prevent="onStartTime(false)">
              <i v-if="!loading" class="fa fa-play fa-fw"></i>
              <i v-else class="fas fa-circle-notch spin"></i>
              {{ $t('restaurantSale.startTime') }}
            </ts-button>
            <ts-button v-else class="btn-warning" @click.prevent="onEndTime()">
              <i v-if="!loading" class="fa fa-pause fa-fw"></i>
              <i v-else class="fas fa-circle-notch spin"></i>
              {{ $t('restaurantSale.endTime') }}</ts-button>
          </div>
        </div>
        <div class="table-info-col">
          <div class="table-info-container">
            <span class="icon">
              <span v-show="table.status_id != 1">
                <i class="far fa-calendar-plus"></i>
              </span>
            </span>
            <span class="text">{{ stockOutDate }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2'

export default {
  name: 'TableCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    defaultCurrency: {
      type: String,
      default: ''
    }
  },
  computed: {
    table() {
      return this.product.table
    },
    hasTimeLimit() {
      return this.getMinEndTime() !== null;
    },
    tableStatusClass() {
      if (this.table.status_id == 3) {
        // Additional check for over time within in-use status
        if (this.isTableOverTime()) {
          return 'over-time-alert'
        }
        if (this.isTableNearTime()) {
          return 'near-time-alert'
        }
        return 'in-use'
      }

      return 'available'
    },
    minutesUsed() {
      if (!this.product.start_time) {
        return 'N/A'
      }

      let diff = moment().diff(moment(this.product.start_time))

      if (this.product.end_time) {
        diff = moment(this.product.end_time).diff(moment(this.product.start_time))
      }
      // const diff = moment().diff(moment(this.product.start_time))

      const duration = moment.duration(diff)
      const hours = duration.hours()
      const minutes = duration.minutes()

      if (hours > 0) {
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
      }

      return `${minutes}m`
    },
    startTime() {
      if (this.product.start_time) {
        return moment(this.product.start_time).format("hh:mm A");
      }
      return 'N/A'
    },
    endTime() {
      if (this.product.end_time) {
        return moment(this.product.end_time).format("hh:mm A");
      }
      if (this.product.start_time) {
        const minEndTime = this.getMinEndTime();
        return minEndTime ? minEndTime.format("hh:mm A") : 'N/A'
      }
      return 'N/A'
    },
    stockOutDate() {
      if (this.product.stock_out_date) {
        return moment(this.product.stock_out_date).format("hh:mm A");
      }
      return 'N/A'
    },
  },
  methods: {
    fetchTables(attributes) {
      this.$emit('fetchTableByInterval', attributes);
    },
    onConfrim(response) {
      Swal.fire({
        icon: 'warning',
        html: '<b>' + response.message + '</b><br />' +
          (response.next_locker_message ? response.next_locker_message : ''),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Confirm"
      })
        .then((result) => {
          if (result.value) {
            this.onStartTime(true)
          }
        });
    },
    onStartTime(confrim) {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/serviceDurationDetail', {
          stock_out_id: this.product.stock_out_id,
          product_id: this.product.product_id,
          ref_table_id: this.product.ref_table_id,
          start_time: this.product.start_time,
          end_time: this.product.end_time,
          service_length: this.product.service_length,
          is_pre_charge: this.product.is_pre_charge,
          action_type: 'start-time',
          confrim: confrim
        })
        .then((response) => {
          // this.$emit('cancel');
          if (response.table_id) {
            this.$notification['warning']({
              message: 'SERVICE DURATION',
              description: response.message,
              placement: 'bottomRight'
            })
            this.onConfrim(response)
          } else {
            this.$notification['success']({
              message: 'SERVICE DURATION',
              description: response.message,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'SERVICE DURATION',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.fetchTables()
          this.loading = false
        })
    },
    onEndTime() {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/serviceDurationDetail', {
          stock_out_id: this.product.stock_out_id,
          product_id: this.product.product_id,
          ref_table_id: this.product.ref_table_id,
          start_time: this.product.start_time,
          end_time: this.product.end_time,
          service_length: this.product.service_length,
          is_pre_charge: this.product.is_pre_charge,
          action_type: 'end-time'
        })
        .then((response) => {
          this.$notification['success']({
            message: 'SERVICE DURATION',
            description: response.message,
            placement: 'bottomRight'
          })
          // this.$emit('cancel');
          if (response.table_id) {
            Swal.fire({
              icon: 'info',
              html: response.message +
                '<br /><b>' +
                (response.next_locker_message ? response.next_locker_message : '') + '</b>'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'SERVICE DURATION',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.fetchTables()
          this.loading = false
        })
    },
    getMinEndTime() {
      //Main linked table case
      if (this.product.start_time && !this.product.end_time) {

        const minEndTime = moment(this.product.start_time).add(this.product.service_length, 'minutes');

        if (!minEndTime) {
          return null // No time limit
        }

        return minEndTime
      }
      return null
    },

    isTableOverTime() {
      // Check if table has been occupied for more than the max service length
      if (!this.product.start_time || !this.hasTimeLimit) {
        return false
      }

      if (!this.table.start_time) {
        return false
      }

      const minEndTime = this.getMinEndTime()

      if (minEndTime) {
        return moment().isAfter(minEndTime);
      }

      return false
    },
    isTableNearTime() {
      const timeLeft = this.calculateTimeLeft()
      return timeLeft > 0 && timeLeft <= 15 * 60 * 1000
    },
    calculateTimeLeft() {
      if (!this.table.start_time || !this.hasTimeLimit) {
        return 0
      }

      const now = moment()

      if (!this.table.start_time) {
        return 0
      }

      const minEndTime = this.getMinEndTime()

      if (minEndTime) {
        if (now.isBefore(minEndTime)) {
          return minEndTime.diff(now);
        }
      }
      return 0;
    },
    getStatusText() {
      // Return appropriate text for non-active tables
      switch (this.table.status_id) {
        case 1:
          return 'Available'
        case 2:
          return 'Disabled'
        case 4:
          return 'Over Time'
        default:
          return ''
      }
    }
  },
  mounted() {
    if (this.table.status_id === 3 && this.hasTimeLimit) {
      this.countdownInterval = setInterval(() => {
        this.$forceUpdate() // Force re-render to update countdown
      }, 1000)
    }
  },

  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  data() {
    return {
      countdownInterval: null,
      loading: false
    }
  }
}
</script>

<style scoped lang="scss">
/* Add styles for countdown timer */
.countdown {
  font-weight: bold;
}

.countdown-timer {
  color: #007bff;
  /* Blue color for active countdown */
  font-size: 1.1em;
}

.countdown-timer.overtime {
  color: #dc3545;
  /* Red color for overtime */
  animation: blink 1s infinite;
}

.status-text {
  color: #6c757d;
  /* Gray color for status text */
  font-size: 0.9em;
}

@keyframes blink {

  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0.3;
  }
}

/* Additional styling for over-time-alert tables */
.table.over-time-alert .countdown-timer {
  color: #dc3545;
  animation: blink 1s infinite;
}

/* 15-minute pre-warning */
.table.near-time-alert .countdown-timer {
  color: #fd7e14;
  animation: blink 1s infinite;
}

.context-menu {
  padding: 6px 0px;
  position: fixed;
  /* so it follows cursor */
  background: white;
  border: 1px solid #ccc;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
  border-radius: 4px;
}

.ivu-list-item {
  white-space: nowrap;
  padding: 6px 8px;
}

.ivu-list-item:hover {
  background-color: #e2e8f0;
}

.table-length {
  position: absolute;
  top: 10px;
  left: 5px;
  height: 8px;
  display: flex;
  align-items: center;
}

.bg-overtime {
  background: rgba(255, 69, 0, 0.8);
}

.pos-counter .pos-counter-body .pos-counter-content .table-row .table.over-time-alert .table-container:after {
  display: none;
}

.btn {
  width: 100%;
  height: 20px;
  padding: 0px 12px !important;
  text-align: left;
}

.table.in-use:hover:not(.disabled) .table-container {
  container: block !important;
  background: #495057 !important;
}

.table.in-use:hover:not(.disabled) .table-container::before {
  container: block !important;
  background: none !important;
  display: none !important;
}

.table.in-use:hover:not(.disabled) .table-container::after {
  container: block !important;
  background: none !important;
  display: none !important;

}

.table.over-time-alert:hover:not(.disabled) .table-container {
  container: block !important;
  /* background: #495057 !important; */
}

.table.over-time-alert:hover:not(.disabled) .table-container::before {
  container: block !important;
  background: none !important;
  display: none !important;
}

.table.over-time-alert:hover:not(.disabled) .table-container::after {
  container: block !important;
  background: none !important;
  display: none !important;

}

.table-container::before {
  contain: none !important;
}

.table.in-use .table-container::before {
  container: none !important;
}

.pos-counter .pos-counter-body .pos-counter-content .table-row .table {
  width: 25%;
  flex: 0 0 25%;

  @media (max-width: 75em) {

    /* ~992px */
    flex: 0 0 33.33%;
    /* 3 per row */
    width: 33.33%;
  }

  @media (max-width: 54em) {

    /* ~768px */
    flex: 0 0 50%;
    /* 2 per row */
    width: 50%;
  }

  @media (max-width: 37.5em) {

    /* ~480px */
    flex: 0 0 100%;
    /* 1 per row */
    width: 100%;
  }
}
</style>